import Echo from 'laravel-echo'

window.pusher = require('pusher-js')

const token = localStorage.getItem('token')

window.Echo = new Echo({
  broadcaster: 'pusher',
  key: process.env.VUE_APP_PUSHER_KEY,
  cluster: 'eu',
  authEndpoint: process.env.VUE_APP_API_HOST + '/broadcasting/auth',
  encrypted: true,
  auth: {
    headers: {
      authorization: 'Bearer ' + token
    }
  }
})